import {
  DialogContent,
  DialogTitle,
  DialogActions,
  Stack,
  Typography,
} from "@mui/material";
import Dialog from "../core/Dialog";
import { IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Button from "src/components/core/Button";
import { useState } from "react";
import DateSelected from "./DateSelected";
import SellerSelected from "./SellerSelected";
import CarrierSelected from "./CarrierSelected";
import FailedReasonSelected from "./FailedReasonSelected";

const FilterDialog = ({
  dataSearch,
  onClose = () => {},
  onConfirm = () => {},
  dateLabel = "",
  isFilterSeller = false,
  isCarrier = false,
  isFailedReason = false,
}) => {
  const [filterData, setFilterData] = useState({
    date: dataSearch?.date ? new Date(dataSearch?.date) : null,
    seller: dataSearch?.seller ? dataSearch?.seller : "",
    carrier: dataSearch?.carrier ? dataSearch?.carrier : "",
    failedReason: dataSearch?.failedReason ? dataSearch?.failedReason : "",
  });

  const styles = {
    default: "#2979ff",
    color: "#252525",
  };

  return (
    <Dialog
      onClose={onClose}
      aria-labelledby="customized-dialog-title"
      open={true}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: 1024,
            maxWidth: "100%",
          },
        },
        "& .MuiDialogContent-root": {
          pt: 1,
          pb: 4,
        },
      }}
    >
      <DialogTitle
        sx={{ display: "flex", justifyContent: "space-between", p: 3 }}
      >
        <Typography
          variant="h6"
          sx={{
            color: styles.color,
            alignContent: "center",
          }}
        >
          ตัวกรอง
        </Typography>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{ color: styles.color }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Stack direction="column" gap="12px">
          <Typography variant="subtitle1" sx={{ color: styles.color }}>
            {dateLabel}
          </Typography>

          <DateSelected
            dateLabel={dateLabel}
            dataSearch={filterData}
            setDataSearch={setFilterData}
            isFullWidth={true}
          />

          {isFilterSeller && (
            <>
              <Typography variant="subtitle1" sx={{ color: styles.color }}>
                ร้านค้า
              </Typography>
              <SellerSelected
                dataSearch={filterData}
                setDataSearch={setFilterData}
                isFullWidth={true}
              />
            </>
          )}

          {isCarrier && (
            <>
              <Typography variant="subtitle1" sx={{ color: styles.color }}>
                {`ขนส่ง`}
              </Typography>
              <CarrierSelected
                dataSearch={filterData}
                setDataSearch={setFilterData}
              />
            </>
          )}

          {isFailedReason && (
            <>
              <Typography variant="subtitle1" sx={{ color: styles.color }}>
                {`สาเหตุที่ยกเลิก`}
              </Typography>
              <FailedReasonSelected
                dataSearch={filterData}
                setDataSearch={setFilterData}
              />
            </>
          )}
        </Stack>
      </DialogContent>

      <DialogActions
        sx={{
          justifyContent: "center",
        }}
      >
        <Button
          variant="outlined"
          size="large"
          onClick={onClose}
          sx={{
            width: "100%",
            minWidth: 100,
            maxWidth: 200,
          }}
        >
          ยกเลิก
        </Button>
        <Button
          variant="contained"
          size="large"
          onClick={() => {
            onConfirm(filterData);
            onClose();
          }}
          sx={{
            width: "100%",
            minWidth: 100,
            maxWidth: 200,
          }}
          // autoFocus // enable auto focus to increase accessibility
        >
          ยืนยัน
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FilterDialog;
